<p-chart
  class="w-full h-full"
  type="bar"
  [data]="chartData"
  [options]="chartOptions"
></p-chart>
